export const ROUTE_HOME = '/'
export const ROUTE_FLOATING_CHAT = '/floating-button'
